export default "__VITE_ASSET__DkYn1c$$__"